import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css } from 'lit'

export const style = css`
  .zip-search { 
    display: flex;
    flex-direction: column;
    gap: var(--csc-delivery-match-zip-search-gap, ${csSpacing.spacing05});
    padding-block: var(--csc-delivery-match-zip-search-padding-y, 0);
    padding-inline: var(--csc-delivery-match-zip-search-padding-x, 0);
    background-color: var(--csc-delivery-match-zip-search-background-color, transparent);
    border-radius: var(--csc-delivery-match-zip-search-border-radius, 0);
  }

`
